import { render, screen } from "@testing-library/react";
import CatalogGroup from "../../../lib/ReactViews/DataCatalog/CatalogGroup";
import { ThemeProvider } from "styled-components";
import { terriaTheme } from "../../../lib/ReactViews/StandardUserInterface";
import { jsx as _jsx } from "react/jsx-runtime";
describe("CatalogGroup React", () => {
  describe("Loading", () => {
    it("Shows loader", () => {
      render(/*#__PURE__*/_jsx(ThemeProvider, {
        theme: terriaTheme,
        children: /*#__PURE__*/_jsx(CatalogGroup, {
          open: true,
          t: () => {},
          loading: true,
          emptyMessage: "nothing here"
        })
      }));
      // Loader renders a spinning element
      expect(screen.getByText("loader.loadingMessage")).toBeVisible();
      // No empty message
      expect(screen.queryByText("nothing here")).not.toBeInTheDocument();
    });
    it("Doesn't show children when loading", () => {
      render(/*#__PURE__*/_jsx(ThemeProvider, {
        theme: terriaTheme,
        children: /*#__PURE__*/_jsx(CatalogGroup, {
          open: true,
          t: () => {},
          loading: true,
          children: /*#__PURE__*/_jsx("span", {
            children: "some child"
          })
        })
      }));
      expect(screen.getByText("loader.loadingMessage")).toBeVisible();
      expect(screen.queryByText("some child")).not.toBeInTheDocument();
    });
    it("Shows children when not loading", () => {
      render(/*#__PURE__*/_jsx(ThemeProvider, {
        theme: terriaTheme,
        children: /*#__PURE__*/_jsx(CatalogGroup, {
          open: true,
          t: () => {},
          loading: false,
          children: /*#__PURE__*/_jsx("span", {
            children: "some child"
          })
        })
      }));
      expect(screen.queryByText("loader.loadingMessage")).not.toBeInTheDocument();
      expect(screen.getByText("some child")).toBeTruthy();
    });
  });
  describe("Empty", () => {
    it("Shows empty message", () => {
      render(/*#__PURE__*/_jsx(CatalogGroup, {
        t: () => {},
        open: true,
        emptyMessage: "nothing here",
        loading: false,
        children: []
      }));
      expect(screen.getByText("nothing here")).toBeTruthy();
    });
  });
});